var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './CalendarsWrapper.module.scss';
import { uppercaseFirstLetter } from 'src/shared/helpers/stringHelpers';
import { useEffect, useRef, useState } from 'react';
import { getNow } from 'src/shared/helpers/dateHelpers';
import { CalendarDays } from 'src/ui/components/Input/DateTimeInput/components/CalendarDays';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import classNames from 'classnames';
import { IDENTIFIER_DATETIME_INPUT_CALENDAR } from 'src/ui/components/Input/DateTimeInput/constants';
export var defaultRange = [
    getNow().minus({ months: 1 }),
    getNow(),
    getNow().plus({ months: 1 }),
    getNow().plus({ months: 2 }),
];
export var updateMonthsRange = function (currentMonthsRange, isBefore) {
    if (isBefore) {
        return currentMonthsRange.map(function (m) { return m.minus({ months: 1 }); });
    }
    else {
        return currentMonthsRange.map(function (m) { return m.plus({ months: 1 }); });
    }
};
var CALENDAR_WIDTH = 300;
export var CalendarsWrapper = function (props) {
    var onDayClick = props.onDayClick, startDate = props.startDate, endDate = props.endDate;
    var _a = useState(defaultRange), currentMonths = _a[0], setCurrentMonths = _a[1];
    var calendarsWrapperRef = useRef(null);
    useEffect(function () {
        if (calendarsWrapperRef === null || calendarsWrapperRef === void 0 ? void 0 : calendarsWrapperRef.current) {
            // second element
            calendarsWrapperRef.current.scrollTo({ left: CALENDAR_WIDTH });
        }
    }, [currentMonths]);
    var handleOnScroll = function (e) {
        e.preventDefault();
        var _a = e.target, scrollLeft = _a.scrollLeft, clientWidth = _a.clientWidth;
        // we check if scroll is correctly snapping to trigger end scroll callback
        // CALENDAR_WIDTH is size of one element, to improve robustness use Ref and child width
        // 1 is scroll reference index
        if (scrollLeft === 0 || (scrollLeft / CALENDAR_WIDTH) % 1 === 0) {
            var monthIndex = Math.ceil(scrollLeft / (clientWidth / 2));
            if (monthIndex < 1) {
                setCurrentMonths(updateMonthsRange(currentMonths, true));
            }
            else if (monthIndex > 1) {
                setCurrentMonths(updateMonthsRange(currentMonths, false));
            }
        }
    };
    var handleLeftClick = function (e) {
        e.stopPropagation();
        if (calendarsWrapperRef === null || calendarsWrapperRef === void 0 ? void 0 : calendarsWrapperRef.current) {
            calendarsWrapperRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        }
    };
    var handleRightClick = function (e) {
        e.stopPropagation();
        if (calendarsWrapperRef === null || calendarsWrapperRef === void 0 ? void 0 : calendarsWrapperRef.current) {
            calendarsWrapperRef.current.scrollTo({ left: 600, behavior: 'smooth' });
        }
    };
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_DATETIME_INPUT_CALENDAR, ref: calendarsWrapperRef, className: styles.calendarsWrapper, onScroll: handleOnScroll }, { children: [_jsx(Icons, { icon: E_ICONS.ARROW_LEFT, className: classNames(styles.icons, styles.leftArrowIcon), onClick: handleLeftClick }), _jsx(Icons, { icon: E_ICONS.ARROW_RIGHT, className: classNames(styles.icons, styles.rightArrowIcon), onClick: handleRightClick }), currentMonths.map(function (m, index) { return (_jsxs("div", __assign({ className: styles.monthCalendarWrapper }, { children: [_jsx("p", __assign({ className: styles.monthCalendarLabel }, { children: "".concat(uppercaseFirstLetter(m.monthLong), " ").concat(m.year) })), _jsx(CalendarDays, { currentMonth: m.month, currentYear: m.year, onChange: onDayClick, startDate: startDate, endDate: endDate })] }), index)); })] })));
};
